import Vue from 'vue'
import Router from 'vue-router'

import Home from './views/Home.vue'
import Login from './views/Login.vue'
import Register from './views/Register.vue'

import { auth, db } from './firebaseConfig.js'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
          requiresAuth: true
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/register',
      name: 'register',
      component: Register
    },
    {
      path: '/songs',
      name: 'songs',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Songs.vue'),
      meta: {
          requiresAuth: true
      }
    },
    {
      path: '/playlists',
      name: 'playlists',
      component: () => import('./views/Playlists.vue'),
      meta: {
          requiresAuth: true
      }
    },
    {
      path: '/playlist/:id',
      name: 'playlist',
      component: () => import('./views/Playlist.vue'),
      meta: {
          requiresAuth: true
      }
    },
    {
      path: '/song/:id',
      name: 'song',
      component: () => import('./views/Song.vue'),
      meta: {
          requiresAuth: true
      }
    },
    {
      path: '/new',
      name: 'new',
      component: () => import(/* webpackChunkName: "about" */ './views/Upload.vue'),
      meta: {
          requiresAuth: true
      }
    },
    {
      path: '/archive',
      name: 'archive',
      component: () => import('./views/Archive.vue'),
      meta: {
          requiresAuth: true
      }
    },
    {
      path: '/user',
      name: 'user',
      component: () => import('./views/User.vue'),
      meta: {
          requiresAuth: true
      }
    }
  ]
});

let target = '/';
// When user is logged in, push to target
auth.onAuthStateChanged( user => {
    if (user) {
      db.collection('users').doc(user.uid).get()
        .then(doc => {
          if (doc.exists) router.push(target);
        })
    }
});

// Check outh on all routes before navigation
router.beforeEach((to, from, next) => {
  if (to.path !== '/login') target = to.path;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  // Directly check Firebase Auth state instead of relying on loggedInUser
  if (requiresAuth && !auth.currentUser) next('/login');
  else next();
});

export default router;
